module.exports = {
  ACTIVITY_PAGE: 1,
  MEMBERSHIP_PAGE: 2,
  HEADER_TOUR: 3,
};
